export default __webpack_public_path__ + "static/media/cabinet.f3aeef98.svg";